import angular from 'angular';
import StaticUploadController from './static-upload.controller';

export const StaticUploadComponent = {
  selector: 'staticUpload',
  bindings: {
    documentName: '@',
    exit: '&',
  },
  controller: StaticUploadController,
  template: /* html */ `
    <overlay ng-show="true">
      <div class="boxL">
        <div class="intro">
          <h3>{{ $ctrl.documentName }} hochladen</h3>
        </div>

        <form class="default-form" ng-submit="$ctrl.upload()">
          <div class="row">
            <div class="col-md-6 input-wrap">
              <fs-file types="[$ctrl.documentName]" fs-model="$ctrl.uploads.static"  progress="progress"></fs-file>
            </div>
          </div>

          <div class="row btn-wrap">
            <button class="btn-lvl1" type="submit" ng-class="{'btn-sending': $ctrl.sending}" ng-disabled="$ctrl.sending">
              {{ $ctrl.documentName }} hochladen
            </button>
            <button class="btn-lvl3" type="button" ng-click="$ctrl.abort()" ng-if="!$ctrl.sending">
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </overlay>
  `,
};

export default angular.module('directives.staticUpload', [])
  .component(StaticUploadComponent.selector, StaticUploadComponent)
  .name;
